import React from 'react';
import { Table } from 'semantic-ui-react';


const TableRow = (props) => {
  const {
    ix,
    eventTitle,
    competitionTitle,
    teamName,
    robotName,
    orig_price,
    sale_price,
    discount,
    tax,
    total
  } = props;

  return (
    <Table.Row>
      <Table.Cell>{ix}</Table.Cell>
      <Table.Cell>{eventTitle}</Table.Cell>
      <Table.Cell>{competitionTitle}</Table.Cell>
      <Table.Cell>{teamName}</Table.Cell>
      <Table.Cell>{robotName}</Table.Cell>
      <Table.Cell>{orig_price}</Table.Cell>
      <Table.Cell>{discount}</Table.Cell>
      <Table.Cell>{sale_price}</Table.Cell>
      <Table.Cell>{tax}</Table.Cell>
      <Table.Cell>{total}</Table.Cell>
    </Table.Row>
  );
};

export default TableRow;



// WEBPACK FOOTER //
// ./src/private/common/components/TransactionTable/Row.js